import "../../../styles/BlogPost/BlogCard.css";

import Label from "../../atoms/Label";
import React from "react";
import blogImage from "../../../assets/ic_sample_blog.svg";
import { logger } from "../../../utils/logger";
import { useNavigate } from "react-router-dom";

const BlogCard = ({ title, image, description, date, id }) => {
	const navigate = useNavigate();

	const handleClick = (id) => {
		logger.log("Clicked");
		navigate(`/blogs/${id}`); // Replace '/other-component' with the desired path
	};

	return (
		<div className='blog-card' onClick={() => handleClick(id)} style={{ cursor: "pointer" }}>
			<div className='blog-image' style={{ cursor: "pointer" }}>
				<img src={image} alt={title} />
			</div>
			<div className='blog-content' style={{ cursor: "pointer" }}>
				<Label
					style={{
						width: "100%",
						display: "flex",
						flexDirection: "row",
						justifyContent: "flex-start",
						marginBottom: "10px",
						marginTop: "30px",
						cursor: "pointer",
					}}
					label={title}
					fontSize={"24px"}
					color={"#000000"}
					fontWeight={"700"}
					textAlign='left'
				/>
				<Label
					style={{
						width: "100%",
						display: "flex",
						flexDirection: "row",
						justifyContent: "flex-start",
						marginBottom: "45px",
						cursor: "pointer",
					}}
					label={description}
					fontSize={"16px"}
					color={"#000000"}
					fontWeight={"400"}
					textAlign='left'
				/>
				<div className='blog-footer'>
					<span className='date'>{date}</span>
				</div>
			</div>
		</div>
	);
};

export default BlogCard;
